const { s1 = {} } = window;
const userData = s1?.markupModifier || s1?.blockInjector || {};
const tags = { ...s1.wpDataStack, ...userData };

export default tags;
